import { lazy } from 'react';

export const AsyncAIFeedbackFlag = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_search-ai-feedback-flag" */ './ai-feedback-flags'
	).then(({ AIFeedbackFlag }) => ({ default: AIFeedbackFlag })),
);
